import { StoreState } from '../../../../../../store/reducers';
import { Dispatch } from 'redux';
import { DispatchProps, OwnProps, StateProps } from './ContractCreateScreen';
import ContractCreate from './ContractCreateScreen';
import { connect } from 'react-redux';
import { caseNumbersStudent } from '../../../../../../store/actions/case-actions';
import { getStudent } from '../../../../../../store/actions/student-actions';
import { getOrders, getOrdersFully } from '../../../../../../store/actions/order-actions';
import { QueryParams } from '../../../../../../types/grid';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        inProgress: state.contracts.inProgress,
        caseNumbersStudent: state.cases.caseNumbersStudent,
        student: state.students.current,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getCaseNumbersStudent: (id) => dispatch(caseNumbersStudent(id)),
        getStudent: (id) => dispatch(getStudent(id)),
    };
}

const ContractCreateScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(ContractCreate);

export default ContractCreateScreen;
